import { render, staticRenderFns } from "./portalcadastros.vue?vue&type=template&id=2f5c4dbd"
import script from "./portalcadastros.vue?vue&type=script&lang=js"
export * from "./portalcadastros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports